import { useMutation } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import {
	CreateSubscriptionFromPricebookItemIdRequest,
	CreateSubscriptionFromOfferResult,
	OperationResult,
} from '../../../admin/components/tools/PricingWizard/types';

export function useCreateSubscriptionMutation() {
	const userSession = useAdminUserSession();
	return useMutation({
		mutationFn: async (request: CreateSubscriptionFromPricebookItemIdRequest) => {
			const response = await userSession.webServiceHelper.callAsync<OperationResult<CreateSubscriptionFromOfferResult>>(
				'admin/BillingUtilities/CreateSubscriptionFromPricebookItemId',
				'POST',
				request
			);

			// Handle both wrapped response { success, value } and unwrapped response
			// callAsync may or may not unwrap the response depending on the endpoint
			if ('value' in response && 'success' in response) {
				// Wrapped response
				if (!response.success || !response.value) {
					throw new Error(response.error || 'Failed to create subscription');
				}
				return response.value;
			}

			// Already unwrapped - return as-is
			return response as unknown as CreateSubscriptionFromOfferResult;
		},
	});
}
